<div class="hmhs-dynamic-form mat-typography mat-body mat-app-background">

  <!-- Form Page Heading -->
  @if (formConfig.pages[currentPage]?.showPageHeader) {
    <h1 class="form-heading">
    {{formConfig.pages[currentPage]?.pageHeader}}</h1>
  }

  <!-- Form Entries Loop -->
  @for (entry of formConfig.pages[currentPage]?.entries; track entry; let i = $index) {
    <div class="form-row"
      [ngClass]="{ 'hide-entry': entry.base?.foreverHidden }">
      <ptl-entry-as-json [entryConfig]="entry" [form]="pageFormGroups" [formConfig]="formConfig">
      </ptl-entry-as-json>
    </div>
  }


  <!-- Form Page Nav BUTTONS -->
  <div class="form-buttons">

    @if (formConfig.form.formNavigation.saveButton?.display) {
      <div class="save-later">
        <a href="javascript:void(0)" (click)="saveForLaterButton()">
          <span class="text">SAVE FOR LATER</span>
          <span class="material-symbols-outlined save-icon">save</span>
        </a>
      </div>
    }

    <div class="navigational-controls">
      @if (formConfig.form.formNavigation.backButton?.display && currentPage !== 0) {
        <div class="nav-link">
          <a href="javascript:void(0)" (click)="backButton()">
            <span class="material-symbols-outlined">arrow_back</span>
            <span class="text left-text">{{ formConfig.form.formNavigation.backButton.content || "BACK" }}</span>
          </a>
        </div>
      }

      @if (formConfig.form.formNavigation.nextButton.display && currentPage !== formConfig.pages.length - 1) {
        <div class="nav-link spacer"
          >
          <a href="javascript:void(0)" (click)="nextButton()"
            [ngClass]="{'disable-link' : formConfig.form.formNavigation?.nextButton?.disable }">
            <span class="text"> {{ formConfig.form.formNavigation.nextButton.content || "NEXT" }}</span>
            <span class="material-symbols-outlined">arrow_forward</span>
          </a>
        </div>
      }
    </div>

    @if (isLoading) {
      <mat-spinner [diameter]="30"></mat-spinner>
    }
    @if (!isLoading && formConfig.form.formNavigation?.submitButton?.display && currentPage === formConfig.pages.length - 1) {
      <button mat-raised-button color="primary" class="submit-button"
        (click)="submitButton()"
        [ngClass]="{'disable-link' : formConfig.form.formNavigation?.submitButton?.disable }">
        {{ formConfig.form.formNavigation.submitButton.content || "SUBMIT" }}
      </button>
    }

  </div>

  <br/>
  @if (errorMsg) {
    <mat-error>{{ errorMsg }}</mat-error>
  }

</div>